import { defineMessages } from 'react-intl';

export default defineMessages({
	helpCenterLabel: {
		defaultMessage: 'Help Center',
		description: 'Heading label for the help center displayed in the sidebar header',
		id: 'sidebar.help-center.header.helpcenter.label',
	},
	helpHubLabel: {
		defaultMessage: 'Help center',
		description: 'Heading label for the help hub displayed in the sidebar header',
		id: 'sidebar.help-center.header.helphub.label',
	},
	helpCenterImageAltLabel: {
		defaultMessage: 'help center icon',
		description: 'Label for help center icon in sidebar',
		id: 'sidebar.help-center.header.helpcenter.image.alt.label',
	},
});
